export default "__VITE_ASSET__CCO45rDR__"